module.exports = __webpack_public_path__ + "static/media/editButton.89d6646c.svg";